// extracted by mini-css-extract-plugin
module.exports = {"NoMargin":"NoMargin--xTUgE","Tabs":"Tabs--iEG4y"};